// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-form-element__label{min-height:24px}`, "",{"version":3,"sources":["webpack://./Resources/assets/app/components/shared/textFormElement/textFormElement.scss"],"names":[],"mappings":"AAEE,0BACE,eAAA","sourcesContent":[".text-form-element {\n\n  &__label {\n    min-height: 24px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
